import React from 'react';
import { CmsEntities } from 'client/data/models/cms';
import { EmbeddedYoutubeAsync } from 'site-modules/shared/components/video/embedded-youtube/embedded-youtube-async';

export function ArticleVideo({ entry }) {
  const videoId = entry.metadata('youtube-videoid').value();
  const videoTitle = entry.metadata('videoTitle').value();
  const thumbnailSrc = entry.metadata('thumbnailURL').value();
  const videoAspectRatio = entry.metadata('videoAspectRatio').value();

  if (!videoId) {
    return null;
  }

  return (
    <EmbeddedYoutubeAsync
      videoId={videoId}
      videoTitle={videoTitle}
      creativeId={`video-${videoId}`}
      thumbnailSrc={thumbnailSrc}
      videoAspectRatio={videoAspectRatio}
    />
  );
}

ArticleVideo.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
